import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { REDIRECT_URL } from '../api/EndPoints';

const SEO = ({ title, path, description }) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="url" content={`${REDIRECT_URL}/${path}`} />
        </Helmet>
    );
};

SEO.propTypes = {
    title: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

export default SEO;
